import React from "react";
import "./Module6.css";
import { FaRocket, FaTrophy, FaStar, FaKey } from "react-icons/fa"; // Ícones para o quadro
import "./Module2.css";
import CalendlyButton from './components/CalendlyButton';

import "./styles.css";

const Module6 = () => {
  return (
    <div
      className="container mt-5 mb-5 custom-container"
      style={{
        backgroundColor: "#000",
        color: "#fff",
        padding: "40px",
        border: "2px solid #fff",
        borderRadius: "0px 90px 0px 90px",
      }}
    >
      <div className="p-2 container">
        <h1
          className="text-center fw-bold special-font text-white"
          style={{ letterSpacing: "8px", lineHeight: "28px" }}
        >
          <p
            className=""
            style={{
              color: "#ECA600",
              fontSize: "18px",
              lineHeight: "22px",
            }}
          >
            UM CONVITE EXCLUSIVO
          </p>{" "}
          SEJA PIONEIRO
        </h1>

        {/* TGE */}
        <p
          className="text-start special-font text-white mt-5"
          style={{ fontSize: "18px", letterSpacing: "1.3px" }}
        >
          Investimentos de alto nível têm um custo – e o mercado imobiliário não
          é diferente. Normalmente, investidores pagam uma{" "}
          <span className="fw-bold">Taxa de Intermediação (TDI)</span>{" "}
          sobre cada operação, garantindo acesso às melhores oportunidades e a
          expertise do nosso time.
        </p>

        {/* ISENÇÃO */}
        <p
          className="text-start mt-5 text-white"
          style={{ fontSize: "18px", letterSpacing: "1.8px" }}
        >
          Se você começar a investir conosco agora, terá{" "}
          <span className="fw-bold" style={{ color: "#ECA600" }}>
            isenção vitalícia
          </span>{" "}
          dessa taxa.
        </p>

        {/* PARÁGRAFO DO IR */}
        <p
          className="text-start special-font text-white mt-5"
          style={{
            fontSize: "18px",
            letterSpacing: "1.3px",
            lineHeight: "32px",
          }}
        >
          <span className="fw-bold" style={{ color: "#ECA600" }}>
            E mais:
          </span>{" "}
          sabemos que no Brasil investimentos similares (como FIIs ou Bolsa) são
          tributados a <strong>15%</strong>, enquanto em Portugal a tributação é
          de <strong>28%</strong>. Por isso, sempre que possível, ajustamos a
          rentabilidade bruta dos nossos projetos para que você receba um
          líquido equivalente — ou superior — ao que teria no Brasil.{" "}
          <span className="fw-bold">
            Seu retorno aqui é pensado para ser competitivo em nível
            internacional.
          </span>
        </p>

        {/* LUCRO MAIOR */}
        <p
          className="text-start special-font text-white mt-5 mb-5"
          style={{ fontSize: "18px", letterSpacing: "1.8px" }}
        >
          <span className="fw-bold">
            Toda vez que investir em um novo projeto com a IMO, seu lucro será
            maior do que o de qualquer investidor futuro,
          </span>{" "}
          proporcionando:
        </p>

        {/* QUADRO DE BENEFÍCIOS COM ÍCONES */}
        <p
          className="text-center text-white fw-bold mb-4"
          style={{
            fontSize: "20px",
            letterSpacing: "2px",
            color: "#ECA600",
          }}
        >
          BENEFÍCIOS EXCLUSIVOS PARA INVESTIDORES PIONEIROS
        </p>

        <div
          className="row text-center mt-4"
          style={{ gap: "20px", justifyContent: "center" }}
        >
          {/* Card 1 */}
          <div
            className="col-12 col-md-3 p-3 border rounded-4"
            style={{
              backgroundColor: "#111111",
              color: "#fff",
              minWidth: "220px",
            }}
          >
            <p style={{ fontSize: "32px", color: "#ECA600" }}>👍</p>
            <p className="fw-bold" style={{ fontSize: "18px" }}>
              8% a 25% aa
            </p>
            <p style={{ fontSize: "14px", lineHeight: "20px" }}>
              Melhores taxas do mercado em qualquer tipo de investimento
            </p>
          </div>

          {/* Card 2 */}
          <div
            className="col-12 col-md-3 p-3 border rounded-4"
            style={{
              backgroundColor: "#111111",
              color: "#fff",
              minWidth: "220px",
            }}
          >
            <p style={{ fontSize: "32px", color: "#ECA600" }}>€</p>
            <p className="fw-bold" style={{ fontSize: "18px" }}>
              0% TDI
            </p>
            <p style={{ fontSize: "14px", lineHeight: "20px" }}>
              0% de Taxa de Intermediação de Negócio por toda a vida do
              Investidor da IMO
            </p>
          </div>

          {/* Card 3 */}
          <div
            className="col-12 col-md-3 p-3 border rounded-4"
            style={{
              backgroundColor: "#111111",
              color: "#fff",
              minWidth: "220px",
            }}
          >
            <p style={{ fontSize: "32px", color: "#ECA600" }}>📜</p>
            <p className="fw-bold" style={{ fontSize: "18px" }}>
              0% IMPOSTO ADICIONAL
            </p>
            <p style={{ fontSize: "14px", lineHeight: "20px" }}>
              Bônus equivalente à diferença de impostos (28% PT - 15% BR),
              devolvido no investimento seguinte.
            </p>
          </div>
        </div>

        {/* ROCKET ICON */}
<p
  className="text-center mt-5 mb-2 text-white"
  style={{
    fontSize: "26px", // Aumentei um pouco
    fontWeight: "bold", // Negrito
    letterSpacing: "1.5px",
    paddingTop: "20px",
    paddingBottom: "20px",
    borderTop: "2px solid #ECA600", // Linha separadora em cima
    marginTop: "50px", // Maior respiro antes
  }}
>
  <FaRocket style={{ color: "#ECA600", marginRight: "12px", fontSize: "28px" }} />
  <span style={{ color: "#ECA600" }}>ESSA É UMA OPORTUNIDADE ÚNICA</span>{" "}
  <span style={{ color: "#fff" }}>E NÃO VAI SE REPETIR</span>
</p>

{/* <div className="d-flex justify-content-center align-items-center">
  <button
    className="btn border-0 mb-2 mt-2 px-5 py-3 fw-bold"
    style={{
      backgroundColor: "#ECA600",
      letterSpacing: "1.8px",
      borderRadius: "50px",
      fontSize: "1rem",
      color: "black",
      transition: "all 0.3s ease",
    }}
    onMouseOver={(e) => {
      e.target.style.backgroundColor = "#f0b000";
      e.target.style.color = "#fff";
    }}
    onMouseOut={(e) => {
      e.target.style.backgroundColor = "#ECA600";
      e.target.style.color = "black";
    }}
  >
    SEJA PIONEIRO E TENHA VANTAGENS PARA SEMPRE !!!
  </button>
</div> */}
        <div className="">
        
        <CalendlyButton label="SEJA PIONEIRO E TENHA VANTAGENS PARA SEMPRE !!!" />
      </div>

      </div>
    </div>
  );
};

export default Module6;
